import React, { Component } from "react";
// import { Col } from "react-bootstrap";

class SidebarMenu extends Component {
  render() {
    return (
      <div>
        <ul>
          <li>
            <a href="/nauka/wprowadzenie"> Wprowadzenie </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default SidebarMenu;
